var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("NavBar", {
        attrs: { currentSection: _vm.currentSection },
        on: { navigate: _vm.handleNavigation, download: _vm.handleDownload },
      }),
      _vm._v(" "),
      _vm.currentSection === "home"
        ? _c("HeroSection", { on: { download: _vm.handleDownload } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentSection === "changelog"
        ? _c("ChangelogSection", { on: { download: _vm.handleDownload } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentSection === "home" ? _c("FeaturesSection") : _vm._e(),
      _vm._v(" "),
      _c("FooterSection"),
      _vm._v(" "),
      _c("QrCodeWidget", { ref: "qrCode" }),
      _vm._v(" "),
      _c("PopupAd", { ref: "popupAd", on: { download: _vm.handleDownload } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }